import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "instant" // ou "smooth" si tu préfères
    });
  }, [pathname]);

  return null;
}

export default ScrollToTop;